import api from './api'

const PRODUCTS_URL = '/products'

export default {
  view: function (id) {
    var url = `${PRODUCTS_URL}/${id}`
    return api.newRequest('get', url)
  },
  unlock: function (id) {
    var url = `${PRODUCTS_URL}/${id}/unlock`
    return api.newRequest('get', url)
  },
  save: function (product) {
    var url = `${PRODUCTS_URL}/${product.productId}`
    return api.newRequest('patch', url, product.data)
  },
  exportPDF: function (product) {
    var url = `${PRODUCTS_URL}/${product.productId}/pdf`
    return api.newRequest('get', url, {}, {
      responseType: 'blob'
    })
  }
}
